// eslint-disable-next-line no-unused-vars

function getConfigFile(env){
    var configLocation = (env.NODE_ENV == "production" ? "" : "public/");
    return require("../" + configLocation + "config.json"); //require('../public/config.json'); 
}

var constants = {
    async setGlobalProps(app, env){
        var props = app.config.globalProperties;
        
        var url = env.VUE_APP_API_URL;

        props.$STATE_NAME = "pas-state-";
        props.$DEFAULT_TIMER = 6000;

        props.$OK = "OK"
        props.$FORM_MODE_VIEW = "View"
        props.$FORM_MODE_CREATE = "Create"
        props.$FORM_MODE_EDIT = "Edit"
        props.$FORM_MODE_DELETE = "Delete"
        props.$FORM_MODE_UNCHANGED = "Unchanged"
        props.$FORM_MODE_HISTORY = "History"        
        props.$API_URL = url
        props.$AUTH_URL = url + "auth/menu" //env.VUE_APP_API_URL + "auth/menu"
        props.$UTIL_URL = url + "util/" //env.VUE_APP_API_URL + "util/"s
        props.$FORM_MODE_UPDATE_STATUS = "UpdateStatus"

        // Mode for saving directly from view (no validation)
        props.$FORM_MODE_VIEW_SAVE = "ViewSave"
        props.$FORM_MODE_DRAFT = "Draft";
        props.$FORM_MODE_DRAFT_EDIT = "Draft Edit";
        props.$FORM_MODE_DRAFT_DELETE = "Draft Delete";
        props.$IS_PRINT_DOCUMENT = "FALSE";
        props.$FORM_MODE_EDIT_PIC = "Edit PIC"

        props.$APPROVAL_STATUS = {
            WAITING_FOR_APPROVAL : "WAITING FOR APPROVAL",
            APPROVED : "APPROVED",
            REJECTED : "REJECTED",
            REVISED : "REVISED",
            DONE : "DONE",
            FULL_APPROVAL : "FULL APPROVAL",
            FULL_RELEASE : "FULL RELEASE",
            WAITING_FOR_REVISION : "WAITING FOR REVISION",
            CLOSED : "CLOSED",
            CANCEL : "CANCEL",
            CANCELLED : "CANCELLED",
            IN_PROGRESS : "IN PROGRESS" ,
            DRAFT : "DRAFT",
        }
        props.$BOQ_TYPE = 
        {
            MAIN_SCOPE : "MAIN SCOPE",
            ADDITIONAL_SCOPE_MC0 : "ADDITIONAL SCOPE MC0",
            ADDITIONAL_SCOPE_MC_BETWEEN : "ADDITIONAL SCOPE MC BETWEEN",
            ADDITIONAL_SCOPE_MC100 : "ADDITIONAL SCOPE MC100",
            ADDENDUM_MC0 : "ADDENDUM MC0",
            ADDENDUM_MC_BETWEEN : "ADDENDUM MC BETWEEN",
            ADDENDUM_MC100 : "ADDENDUM MC100",
        }

        props.$USER_LEVEL={
            CONTRACTOR : "CONTRACTOR",
            WILMAR : "WILMAR",
            OUTSOURCING : "OUTSOURCING"
        }

        props.$ACCOUNT = {
            USER : "USER",
            ADMIN_HO : "ADMIN HO",
            ADMIN_UNIT : "ADMIN UNIT",
        }        

        props.$TYPE= [
            "Y","N"
        ]

        props.$MAIN_DATA_STATUS= {
            YA: "Ya",
            TIDAK: "Tidak",
            TERSEDIA : "Tersedia",
            TIDAK_TERSEDIA : "Tidak Tersedia",
            PROCESS : "PROCESS",
            NO_NEED_PROCESS : "NO NEED",
            Require : "Require",
        }

        props.$LOOKUP_GROUP = {
            DOC_CATEGORY_TYPE: "DOC_CATEGORY_TYPE",
            DOC_CATEGORY_EXPIRY: "DOC_CATEGORY_EXPIRY",
            STORAGE_LOCATION_TYPE : "STORAGE_LOCATION_TYPE",
            REPORT_TYPE : "REPORT_TYPE",
            DOCUMENT_STATUS : "DOCUMENT_STATUS" ,
            MOVEMENT_REPORT_TYPE : "MOVEMENT_REPORT_TYPE",
            APPROVAL_AS_MATRIX : "APPROVAL_AS_MATRIX",
            VALIDITY_MATRIX : "VALIDITY_MATRIX",
            DOCUMENT_TRANSFER_TYPE : "DOCUMENT_TRANSFER_TYPE",
            TRANSFER_STATUS : "TRANSFER STATUS",
            RELEASE_MODULE : "RELEASE_MODULE",
            PROGRESS_BAST : "PROGRESS_BAST",
            EVALUASI_BAST_KEBERSIHAN : "EVALUASI_BAST_KEBERSIHAN",
            EVALUASI_BAST_MUTU : "EVALUASI_BAST_MUTU",
            INSPECTION_RESULT_QC : "INSPECTION_RESULT_QC",
            SCOPE_QC_FINAL : "SCOPE_QC_FINAL",
            DEPARTMENT : "DEPARTMENT",
            WORK_GROUP : "WORK_GROUP",
            CURRENCY : "CURRENCY",
            TRANSACTION_STATUS : "TRANSACTION_STATUS",
            API_TRIGGER_LOG : "API_TRIGGER_LOG",
            CATEGORY_DOCUMENT : "CATEGORY_DOCUMENT",
            TYPE_BOQ : "TYPE_BOQ",
            TYPE_COMPONENT: "Type_Component",
            FILTER_DATE_BY : "FILTER_DATE_BY",
            FILTER_DATE_BY_WO : "FILTER_DATE_BY_WO",
        }

        props.$ApprovalMatrixModule =
        {
            MD : "MASTER DATA",
            TRANSACTION : "TRANSACTION",
            RELEASE : "RELEASE",
            CLOSING : "CLOSING",
            WORK_ORDER : "WORK ORDER"

        }

        props.$REQUEST_STATUS = {
            DRAFT  : "DRAFT"
        }
        
        props.$TypeDocument =
        {
           BA_IK_WITH_SPO : "BA-IK with SPO",
           BA_IK_WITHOUT_SPO : "BA-IK without SPO",
           KOM : "KOM",
           DELAY : "DELAY",
           PENALTY : "PENALTY",
           ADDENDUM : "ADDENDUM",
           BAST_TERMIN : "BAST TERMIN",
           FINAL_QC : "FINAL QC",
           BAST_FINAL : "BAST FINAL",
           BAST_RETENSI : "BAST RETENSI",
           BA_CUT_OFF : "BA CUT OFF",
           KOM_QC : "KOM QC",
           MC : "MC",
           MC0 : "MC0",
           MC_BETWEEN : "MC BETWEEN",
           MC100 : "MC100",
           ADDENDUM_MC0 : "ADDENDUM MC0",
           ADDENDUM_MC_BETWEEN : "ADDENDUM MC BETWEEN",
           ADDENDUM_MC100 : "ADDENDUM MC100",
           BAPVA : "BAPVA",
           RKTK : "RKTK",
           ADDENDUMMC : "ADDENDUM MC",
           PROGRESS_TERMIN : "PROGRESS TERMIN",
           PROGRESS_FINAL : "PROGRESS FINAL",

        }

        props.$DOCUMENT_STATUS = {
           DRAFT : "DRAFT",
           NO_NEED_APPROVAL : "NO NEED APPROVAL"
        }

        props.$UserLevel = 
        {
            PROJECT_MANAGER : "PROJECT MANAGER",
            PROJECT_COORDINATOR : "PROJECT COORDINATOR",
            CONTRACTOR : "CONTRACTOR",
            SITE_MANAGER : "SITE MANAGER",
            ADMIN_PROJECT : "ADMIN PROJECT",
            ADMIN_MASTER_DATA : "ADMIN MASTER DATA",
            ADMIN_CONTRACTOR : "ADMIN CONTRACTOR",
            HEAD_UNIT : "HEAD UNIT",
            QC_INSPECTOR :"QC INSPECTOR",
            QC_HEAD : "QC HEAD",
            QC_MEKANKAL : "QC MEKANIKAL",
            QC_SIPIL : "QC SIPIL",
            QC_ELECTRICAL : "QC ELECTRICAL",
            REVIEW : "REVIEW",
            LEAD_ENGINEERING : "LEAD ENGINEERING",
            ADMIN_QC : "ADMIN QC",
            HEAD_PROJECT_DEPARTMENT : "HEAD PROJECT DEPARTMENT",
            HEAD_USER : "HEAD USER",
            PIC_ENGINEERING : "PIC ENGINEERING",
            ADMINISTRATOR : "ADMINISTRATOR",
            ADMIN_WO_PROJECT : "ADMIN WO PROJECT",
            ADMIN_WO_NON_PROJECT : "ADMIN WO NON PROJECT",
            PROJECT_MANAGER_CONTRACTOR : "PROJECT MANAGER CONTRACTOR",
            PIC_CREATOR_AR : "PIC CREATOR AR",
            SECTION_HEAD : "SECTION HEAD",
            QUANTITY_SURVEYOR : "QUANTITY SURVEYOR",
            QS_CONTRACTOR : "QUANTITY SURVEYOR CONTRACTOR",
            ADMIN_PROJECT : "ADMIN PROJECT",
            FACTORY_MANAGER : "FACTORY MANAGER",
            OPERATION_HEAD : "OPERATION HEAD",
            SITE_PIC : "SITE PIC",
            PROJECT_ENGINEER : "PROJECT ENGINEER",
        }

        props.$UserType = 
        {
            WILMAR : "WILMAR",
            CONTRACTOR : "CONTRACTOR",
        }


        props.$CATEGORYMD={
            USER : "USER",
            CONTRACTOR : "CONTRACTOR",
            COMPANY : "COMPANY"
        }

        props.$Accept_Repair={
            ACCEPTED  : "ACCEPTED",
            REPAIR : "REPAIR"
        }

        props.$JOBPOSITION={
            REVIEW  : "REVIEW"
        }

        props.$VALIDITY = {
            EITHER : "EITHER",
            ALL : "ALL"
        }

        props.$RESULT = {
            ONTARGET : "ON TARGET",
            DELAYED : "DELAYED"
        }
        
        props.$DOCUMENTFOOTER = {
            APPROVED_GENERATED : "Document & Approval (Name & Timestamp) generated by Project Administration Platform - Wilmar",
            GENERATED : "Document generated by Project Administration System - Wilmar"
        }

        props.$FullNameDoc =
        {
           BA_IK_WITH_SPO : "Berita Acara Instruksi Kerja (BAIK) - with SPO",
           BA_IK_WITHOUT_SPO : "Berita Acara Instruksi Kerja (BAIK) - without SPO",
           KOM : "Kick Off Meeting (KoM)",
           DELAY : "Berita Acara (BA) - Delay",
           PENALTY : "Surat Penalty",
           ADDENDUM : "Berita Acara (BA) - Addendum",
           BAST_TERMIN : "Berita Acara Serah Terima (BAST) - Termin",
           FINAL_QC : "Final Quality Control (QC)",
           BAST_FINAL : "Berita Acara Serah Terima  (BAST) - Final",
           BAST_RETENSI : "Berita Acara Serah Terima  (BAST) - Retensi",
           BA_CUT_OFF : "Berita Acara Serah Terima  (BAST) - Retensi",
           KOM_QC : "Kick Off Meeting QC (KoM QC)",
           MC0 : "Mutual Check (MC) - 0",
           MC_BETWEEN : "Mutual Check (MC) - in Between",
           MC100 : "Mutual Check (MC) - 100",
           ADDENDUM_MC0 : "Addendum Mutual Check (MC) - 0",
           ADDENDUM_MC_BETWEEN : "Addendum Mutual Check (MC) - in Between",
           ADDENDUM_MC100 : "Addendum Mutual Check (MC) - 100",
           PROGRESS_TERMIN : "Progress Report Termin",
           PROGRESS_FINAL : "Progress Report Final",
        }

        props.$TypeNameMC = 
        {
            MC0 : "(MC)-0",
            MC_BETWEEN : "(MC)-in Between",
            MC100 : "(MC)-100"
        }
        props.$TypeMC = 
        {
            MC0 : "MC0",
            MC_BETWEEN : "MC BETWEEN",
            MC100 : "MC100"
        }
        props.$DEPARTMENT = {
            NON_PROJECT	: "NON PROJECT",
            PROJECT : "PROJECT"	
        }

        props.$WorkGroup = 
        {
            Project_Execution : "Project Execution",
            Project_Engineering : "Project Engineering",
            Project_Admin_Creator_AR : "Project Admin/Creator AR",
            Project_Drafter : "Project Drafter"
        }

        props.$CategoryWo =
        {
            Execution : "Execution",
            Engineering : "Engineering",
            Admin_AR : "Admin AR",
            Drafter : "Drafter",
            NON_PROJECT_ENGINEERING : "NON PROJECT ENGINEERING",
            NON_PROJECT_EXECUTION : "NON PROJECT EXECUTION"
        }

        props.$dataChangesLog = [
            {field:"ChangedBy", header:"Edited By"},
            {field:"ChangedDate", header:"Edited Date"},
            {field:"TableName", header:"Table Name"},
            {field:"ColumnName", header:"Field Name"},
            {field:"ValueFrom", header:"Old Value"},
            {field:"ValueTo", header:"New Value"},
            {field:"Status", header:"Status"},
        ]
        props.$dataChangesLog2 = [
            {field:"ChangedBy", header:"Edited By"},
            {field:"ChangedDate", header:"Edited Date"},
            {field:"DocNo", header:"Document No"},
            {field:"ColumnName", header:"Field Name"},
            {field:"ValueFrom", header:"Old Value"},
            {field:"ValueTo", header:"New Value"},
            {field:"Status", header:"Status"},
        ]
        props.$dataChangesLog3 = [
            {field:"ChangedBy", header:"Edited By"},
            {field:"ChangedDate", header:"Edited Date"},
            {field:"TableName", header:"Table Name"},
            {field:"DocNo", header:"Document No"},
            {field:"ColumnName", header:"Field Name"},
            {field:"ValueFrom", header:"Old Value"},
            {field:"ValueTo", header:"New Value"},
            {field:"Status", header:"Status"},
        ]
        props.$dataChangesLogMasterData = [
            {field:"ChangedBy", header:"Edited By"},
            {field:"ChangedDate", header:"Edited Date"},
            {field:"TableName", header:"Table Name"},
            {field:"DocNo", header:"Document No"},
            {field:"ColumnName", header:"Field Name"},
            {field:"ValueFrom", header:"Old Value"},
            {field:"ValueTo", header:"New Value"},
        ]
        props.$dataRelease = [
            { field: "Action_Role", header: "Role" },
            { field: "Action_By", header: "Name" },
            { field: "Level", header: "Level" },
            //{ field: "Validity", header: "Validity" },
            { field: "Status", header: "Status" }
        ]
    }
}

export default constants

